import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import { getChildrenToRender } from './utils';

import Logo from '../assets/icons/logo_mad.png';
import Enamad from '../assets/icons/enamad-logo.png';

import Instagram from '../assets/icons/instagram.svg';
import Linkedin from '../assets/icons/linkedin.svg';
import Telegram from '../assets/icons/telegram.svg';
import Twitter from '../assets/icons/twitter.svg';


class Footer extends React.Component {
  static defaultProps = {
    className: 'footer1',
  };

  handleClick = () => {
    window.open("https://logo.samandehi.ir/Verify.aspx?id=316854&p=xlaorfthgvkamcsidshwaods", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")
  };

  getLiChildren = (data) =>
    data.map((item, i) => {
      const { title, childWrapper, ...itemProps } = item;
      if (i === 3) {
        return <div key={i.toString()} className="ant-col block ant-col-xs-24 ant-col-md-6">
          <Col key={i.toString()} {...itemProps} title={null} content={null}>
            <a target="_blank" style={{margin:'auto',display:'contents'}}
              href="https://trustseal.enamad.ir/?id=167811&amp;Code=Dpf1WFfN9IIjvV0uDKnh">
              <img src={Enamad} alt="اینماد" style={{cursor:'pointer',width:'125px'}} id="Dpf1WFfN9IIjvV0uDKnh" />
            </a>
            <div style={{marginTop:'15px'}}>
              <img referrerPolicy='origin' id ='rgvjjxlzfukzoeukapfuwlao' style={{cursor:'pointer'}} onClick={this.handleClick} alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=316854&p=qftinbpdwlbqaqgwujynshwl' />
            </div>
          </Col>
        </div>
      } else if (i === 4) {
        return (
          <Col key={i.toString()} className="ant-col block ant-col-xs-24 ant-col-md-8" title={null} content={null}>
            <a href="https://twitter.com/Madtalk_ir" className="social-link"><img src={Twitter} alt="" /></a>
            <a href="https://www.instagram.com/madtalk.ir/" className="social-link"><img src={Instagram} alt="" /></a>
            <a href="https://t.me/madtalk_ir" className="social-link"><img src={Telegram} alt="" /></a>
            {/* <a href="https://www.instagram.com/madtalk.ir/" className="social-link"><img src={Linkedin} alt="" /></a> */}
          </Col>
        )
      } else {
        return (
          <Col key={i.toString()} {...itemProps} title={null} content={null}>
            <h2 {...title}>
              {typeof title.children === 'string' &&
                title.children.match('logo') ? (
                  <img src={Logo} width="80%" alt="img" />
                ) : (
                  title.children
                )}
            </h2>
            <div {...childWrapper}>
              {childWrapper.children.map(getChildrenToRender)}
            </div>
          </Col>
        );
      }
    });

  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const childrenToRender = this.getLiChildren(dataSource.block.children);
    return (
      <div {...props} {...dataSource.wrapper}>
        <OverPack {...dataSource.OverPack}>
          <QueueAnim
            type="bottom"
            key="ul"
            leaveReverse
            component={Row}
            {...dataSource.block}
          >
            {childrenToRender}
          </QueueAnim>
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from' }}
            key="copyright"
            {...dataSource.copyrightWrapper}
          >
            <div {...dataSource.copyrightPage}>
              <div {...dataSource.copyright}>
                {dataSource.copyright.children}
              </div>
            </div>
          </TweenOne>
        </OverPack>
      </div>
    );
  }
}

export default Footer;
